module.exports = __webpack_public_path__ + "img/qr-icon.76807401.png";